import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import App from "./App";
import axios from "axios";
import { watchForMaintenance } from "./utils/maintenance";

window.Buffer = window.Buffer || require("buffer").Buffer;
// Raw axios calls (outside axiosInstance) also go to the maintenance page during a platform update.
watchForMaintenance(axios);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );
